export default {
  FETCH_ALL: 'ADMINISTRATORS/FETCH_ALL',
  SET_ALL: 'ADMINISTRATORS/SET_ALL',
  FETCH: 'ADMINISTRATORS/FETCH',
  SET: 'ADMINISTRATORS/SET',
  UPDATE: 'ADMINISTRATORS/UPDATE',
  INVITE: 'ADMINISTRATORS/INVITE',
}
